import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  alertMessage: "",
  showAlert: false,
};

const sifremiUnuttumSlice = createSlice({
  name: "sifremiUnuttum",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setAlertMessage: (state, action) => {
      state.alertMessage = action.payload;
    },
    setShowAlert: (state, action) => {
      state.showAlert = action.payload;
    },
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.alertMessage = "";
      state.showAlert = false;
    },
  },
});

export const {
  setLoading,
  setError,
  setAlertMessage,
  setShowAlert,
  resetState,
} = sifremiUnuttumSlice.actions;
export default sifremiUnuttumSlice.reducer;

export const yeniSifreRequest = (token, newPassword) => async (dispatch) => {
  dispatch(setLoading(true));
  dispatch(setError(null));

  try {
    const response = await api.post("/auth/reset-password", {
      token,
      newPassword,
    });

    if (response.status === 200) {
      dispatch(setAlertMessage("Şifreniz başarıyla güncellendi."));
      dispatch(setShowAlert(true));
    } else {
      dispatch(setError("Bir hata oluştu. Lütfen tekrar deneyiniz."));
    }
  } catch (err) {
    console.error("Error details:", err.response?.data);
    const errorMessage =
      err.response?.data?.message ||
      "Bir hata oluştu. Lütfen tekrar deneyiniz.";
    dispatch(setError(errorMessage));
  } finally {
    dispatch(setLoading(false));
  }
};
